import {createClient} from "@sanity/client";

export const projectId =
  process.env.REACT_APP_SANITY_PROJECT_ID || "d1ppekyj";
export const dataset =
  process.env.REACT_APP_SANITY_DATASET || "production";
export const apiVersion =
  process.env.REACT_APP_SANITY_API_VERSION || "2024-01-19";
const isProduction = process.env.NODE_ENV === "production";

export type SanityFetchClient = {
  fetch: <T>(
    query: string,
    params?: Record<string, unknown>
  ) => Promise<T>;
};

export const sanityClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: isProduction,
}) as unknown as SanityFetchClient;
